export default __webpack_public_path__ + "static/media/pancakeswap.b6964eef.svg";